import {PocsagItem} from '../pocsag/pocsag.module';
import {Injectable} from '@angular/core';
import {Fahrzeug} from '../fahrzeuge/fahrzeuge.model';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class LocalStorageService {
    private app_version = '3.6.3.5';

    constructor(private http: HttpClient) {
    }




    Sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    }




    store(key: string, value: any) {
        // console.log ('[Storage] Store:', key, value);
        localStorage.setItem(key, value);
    }

    get(key: string): any {
        if (key === 'app_version') {
            return this.app_version;
        } else {
            //  console.log ('[Storage] GET:', key, '#', localStorage.getItem (key));
            return localStorage.getItem(key);
        }
    }


    delete(key: string) {
        //  console.log ('[Storage] Delete:', key);
        localStorage.removeItem(key);

    }

    clear() {

        localStorage.clear();
    }




    // Pocsag
    store_PocsagItems(key: string, value: PocsagItem[]) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    get_PocsagItems(key: string) {

        //  console.log ('[Storage] GET: Pocsag');
        const temp: PocsagItem[] = JSON.parse(localStorage.getItem(key));
        return (temp);
    }


    // -----------------------------------------



    // -----------------------------------------



    // -----------------------------------------


    // Fahrzeuge
    store_FahrzeugeItems(value: string) {
        localStorage.setItem('Fahrzeuge', value);
    }

    get_FahrzeugeItems() {
        try {
            const temp: Fahrzeug = JSON.parse(localStorage.getItem('Fahrzeuge'));
            return (temp as unknown as Fahrzeug[]);
        } catch (e) {
        }
    }

    // -----------------------------------------


// Fahrzeuge


    // -----------------------------------------


}
